import {connect} from 'react-redux';
import MediaOrdersItemsContainer from './MediaOrdersListContainer';
import {
    setMediaOrdersListAction,
    resetMediaOrdersListAction,
} from './Redux/MediaOrdersListActions';
import {MediaOrdersListItem} from './MediaOrdersListTypes';

interface State {
    mediaOrders: {
        mediaOrdersList: {rows: MediaOrdersListItem[]; total: number};
    };
    textEnums: {
        labPartners: {[key: string]: string};
    };
}

export const mapState = (state: State) => {
    return {
        mediaOrdersList: state.mediaOrders.mediaOrdersList.rows,
        total: state.mediaOrders.mediaOrdersList.total,
        labPartners: state.textEnums.labPartners,
    };
};

export const mapDispatch = {
    setMediaOrders: setMediaOrdersListAction,
    resetMediaOrders: resetMediaOrdersListAction,
};

export default connect(mapState, mapDispatch)(MediaOrdersItemsContainer);
